import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { CheckCircle } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (password.length < 8) { setError("Password must be at least 8 characters"); return; }
    if (password !== confirm) { setError("Passwords do not match"); return; }
    setLoading(true);
    try {
      await axios.post(`${API}/auth/reset-password`, { token, new_password: password });
      setDone(true);
    } catch (err) {
      setError(err.response?.data?.detail || "Reset failed. Token may be expired.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center px-6">
      <div className="w-full max-w-sm">
        <div className="text-center mb-10">
          <Link to="/" className="font-heading text-3xl text-[#D4AF37] tracking-wider">LUXIFER 6</Link>
          <p className="text-white/40 text-sm mt-2 uppercase tracking-wider">Set New Password</p>
        </div>

        {done ? (
          <div data-testid="reset-success" className="text-center space-y-4">
            <CheckCircle className="w-12 h-12 text-green-500 mx-auto" />
            <p className="text-white/60">Password has been reset successfully.</p>
            <Link to="/admin/login" className="text-sm text-[#D4AF37] hover:underline block">Go to Login</Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-6">
            {!token && <p className="text-red-400 text-sm">No reset token found. Use the link from your reset email.</p>}
            {error && <div data-testid="reset-error" className="text-sm text-red-400 bg-red-400/10 border border-red-400/20 p-3 rounded">{error}</div>}
            <div>
              <label className="text-xs uppercase tracking-wider text-white/40 mb-2 block">New Password</label>
              <input data-testid="reset-password-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Min 8 characters" required
                className="w-full bg-[#111111] border border-white/10 focus:border-[#D4AF37] outline-none p-3 text-white placeholder:text-white/20 rounded transition-colors" />
            </div>
            <div>
              <label className="text-xs uppercase tracking-wider text-white/40 mb-2 block">Confirm Password</label>
              <input data-testid="reset-confirm-input" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} placeholder="Re-enter password" required
                className="w-full bg-[#111111] border border-white/10 focus:border-[#D4AF37] outline-none p-3 text-white placeholder:text-white/20 rounded transition-colors" />
            </div>
            <Button data-testid="reset-submit-btn" type="submit" disabled={loading || !token} className="w-full bg-[#D4AF37] text-black hover:bg-white font-semibold py-3 uppercase tracking-wider text-sm h-auto">
              {loading ? "Resetting..." : "Reset Password"}
            </Button>
          </form>
        )}
      </div>
    </div>
  );
}
